
import emitter from 'toolkit/mixins/emitter.js'

export default {
  mixins: [emitter],
  inject: {
    sForm: {
      default: ''
    },
    sFormItem: {
      default: ''
    }
  },
  methods: {
    $_sendFormItemEvent(value) {
      this.dispatch('sFormItem', 's.form.change', value)
    }
  },
  computed: {
    validateState() {
      return this.sFormItem ? this.sFormItem.validateState : ''
    },
    formItemError() {
      return this.validateState == 'error'
    },
  },
}
